import moment from "moment";
export class StaffEmgCont {
  StaffID;
  Seq;
  tempCode;
  EmgContName;
  ContNum;
  RelateType;
  IsEditMode;
  EmgCont;
  RelateTypeDes;
  constructor() {
    this.StaffID = "";
    this.Seq = "";
    this.tempCode =  "";
    this.EmgContName = "";
    this.ContNum = "";
    this.RelateType = "";
    this.EmgCont = "false";
    this.IsEditMode = false;
    this.RelateTypeDes =  "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffEmgCont.js